import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import { tabsClasses } from "@mui/material/Tabs";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import animation from "../../../images/jm-animation.gif";
import VideoGallery from "../VideoGallery/VideoGallery";
import Calendar2026 from "./Calendar/Calendar2026";
import DocumentGallery from "./DocumentGallery/DocumentGallery";
import "./FinQSection.css";
import Outlook2026 from "./Outlook2026/Outlook2026";
import ByteSizedInsights from "./ByteSizedInsights/ByteSizedInsights";

function FinQSection() {
  const [value, setValue] = useState(1);
  const [loadingshow, setloadingshow] = useState(false);
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  const [pathname, setPathName] = useState("");

  useEffect(() => {
    var pathname = window.location.pathname;
    const regEx = new RegExp("-", "g");
    const resultName = pathname.replace(regEx, " ");
    setPathName(resultName);
  });
 
  useEffect(() => {
    setloadingshow(true);
    const para = window.location.pathname.toLowerCase().split("/")[2];
    if (para === "videogallery") {
      setValue(1);
      setBreadcrumbs(["Insights", "Video Gallery"]);
    } else if (para === "documentgallery") {
      setValue(2);
      setBreadcrumbs(["Insights", "Document Gallery"]);
    } else if (para === "calendar2026") {
      setValue(3);
      setBreadcrumbs(["Insights", "Calendar 2026"]);
    } else if (para === "outlook2026") {     
      setValue(4);
      setBreadcrumbs(["Insights", "Outlook 2026"]);
    }
    setloadingshow(false);
  }, []);

  const arrayOfTabsObj = [
    { name: "Video Gallery", id: 1 },
    { name: "Document Gallery", id: 2 },
    { name: "Calendar 2026", id: 3 },
    { name: "Outlook 2026", id: 4 },
    // { name: "byte sized insights", id: 5 },
  ];

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const navigateToSection = (section) => {
    setValue(section.id);
    setBreadcrumbs(["Insights", section.name]);
    window.history.pushState(
      "",
      "",
      `/Insights/${section.name.replace(/\s/g, "-")}`,
    );
  };


  return (
    <>
      <section className="FinQSection-detail">
        <Container>
          <Row>
            <Col>
            <nav aria-label="Breadcrumb">
              <ul className="navigator-arrow">
                <li>
                  <a href="/" aria-label="Home">
                    <i className="fa fa-home"></i>
                     <span className="sr-only">Home</span>
                  </a>{" "}
                  <i className="fa fa-angle-right"></i>
                </li>
                <li>
                  <a href="/Insights">
                    Insights
                  </a>{" "}
                  <i className="fa fa-angle-right"></i>
                </li>
                {window.location.pathname !== "/Insights" &&
                    pathname.split("/")[2] && (
                      <li>{pathname.split("/")[2]}</li>
                  )}
              </ul>
            </nav>
            </Col>
          </Row>
        </Container>
        <Box>
          <TabContext value={value}>
            <Container className="finqtab">
              <Row>
                <Col sm={12}>
                  <Box
                    sx={{
                      borderBottom: 0,
                      borderColor: "divider",
                      bgcolor: "background.paper",
                    }}
                  >
                    <TabList
                      onChange={handleChange}
                      variant="scrollable"
                      sx={{
                        [`& .${tabsClasses.scrollButtons}`]: {
                          "&.Mui-disabled": { opacity: 0.3 },
                        },
                      }}
                      scrollButtons="auto"
                    >
                      {arrayOfTabsObj.map((item) => (
                        <Tab
                          label={item.name}
                          value={item.id}
                          key={item.id}
                          onClick={() => navigateToSection(item)}
                          disableFocusRipple
                        />
                      ))}
                      {loadingshow && (
                        <div className="textcentervertex" role="status" aria-live="polite" aria-busy="true">
                          <img src={animation} alt="" aria-hidden="true" />
                          <div className="model_popup">Please Wait...</div>
                        </div>
                      )}
                    </TabList>
                  </Box>
                </Col>
              </Row>
            </Container>
            <div className="section-header">
              {/* <h2 className="sectionHeaderFinQ">
                {value === 1 ? "" : arrayOfTabsObj[value - 1].name}
              </h2> */}
              {value !== 1 && (
                  <h2 className="sectionHeaderFinQ">
                    {arrayOfTabsObj[value - 1].name}
                  </h2>
                )}
            </div>
            <TabPanel value={1}>
              <Container>
                <Row>
                  <Col sm={12}>
                    <VideoGallery />
                  </Col>
                </Row>
              </Container>
            </TabPanel>
            <TabPanel value={2}>
              <Container>
                <Row>
                  <Col sm={12}>
                    <DocumentGallery />
                  </Col>
                </Row>
              </Container>
            </TabPanel>

            <TabPanel value={3}>
              <Container>
                <Row>
                  <Col sm={12}>
                    <Calendar2026 />
                  </Col>
                </Row>
              </Container>
            </TabPanel>

            <TabPanel value={4}>
              <Container>
                <Row>
                  <Col sm={12}>
                    <Outlook2026 />
                  </Col>
                </Row>
              </Container>
            </TabPanel>

            {/* <TabPanel value={5}>
              <Container>
                <Row>
                  <Col sm={12}>
                    <ByteSizedInsights />
                  </Col>
                </Row>
              </Container>
            </TabPanel> */}
          </TabContext>
        </Box>
      </section>
    </>
  );
}

export default FinQSection;
